import axios from "axios";
import dayjs from "dayjs";
import { fetchBPLiveDataForCustomer, fetchBPLiveDataForCustomerForOneSite } from "../redux/services/dashboardService";
import { fetchMaintenanceTickets, fetchMaintRegistry } from "../redux/services/maintenanceService";
import type { CustomerSite } from "../redux/types/customerTypes";
import factoryGreen from '../assets/Dashboard/FactoryIconGreen.svg'
import globalDashboard from '../assets/Dashboard/database-01-stroke-rounded 1.png';
import globalDashboardGreen from '../assets/sideNav/selected/Global.svg';
import Maintenance from '../assets/sideNav/Maintenance.svg';
import MaintenanceGreen from '../assets/sideNav/selected/Maintenance.svg';
import Maps from '../assets/sideNav/Maps.svg';
import MapsGreen from '../assets/sideNav/selected/Maps.svg';
import factory from '../assets/Dashboard/FactoryIcon.svg';
import { ALARMS, CAMERAS, CHARGERS, FUEL, GENERAL, GLOBAL_MAPS, MAINTENANCE, MAPS, POWER_GENERATION, REMOTE, REPORTS, SOLAR, STARLINK, LOGS, EVENTS } from "../utils/constants";
import General from '../assets/sideNav/General.svg';
import GeneralGreen from '../assets/sideNav/selected/General.svg';
import Events from '../assets/sideNav/Events.svg';
import EventsGreen from '../assets/sideNav/selected/EventsSelected.svg';
import Charger from '../assets/sideNav/Charger.svg';
import ChargerGreen from '../assets/sideNav/selected/Charger.svg';
import PowerSVG from '../assets/sideNav/Power.svg';
import PowerGreen from '../assets/sideNav/selected/Power.svg';
import Fuel from '../assets/sideNav/Fuel.svg';
import FuelGreen from '../assets/sideNav/selected/Fuel.svg';
import Solar from '../assets/sideNav/Solar.svg';
import SolarGreen from '../assets/sideNav/selected/Solar.svg';
import StarLink from '../assets/sideNav/StarLink.svg';
import StarLinkGreen from '../assets/sideNav/selected/StarLink.svg';
import Reports from '../assets/sideNav/Reports.svg';
import ReportsGreen from '../assets/sideNav/selected/Reports.svg';
import Alarms from '../assets/sideNav/Alarms.svg';
import AlarmsGreen from '../assets/sideNav/selected/Alarms.svg';
import Cameras from '../assets/sideNav/Camera.svg';
import CamerasGreen from '../assets/sideNav/selected/Camera.svg';
import Loki from '../assets/sideNav/Log.svg';
import LokiGreen from '../assets/sideNav/selected/Log.svg';
import { FACTORY_DASHBOARD } from "./constants";
import type { JSX } from "react";
const protocol: any = import.meta.env.VITE_PROTOCOL;
const url: any = import.meta.env.VITE_API_URL;
const authUrl: any = import.meta.env.VITE_AUTH_URL;

export const clearCookie = () => {
    localStorage.removeItem('user');
    // Store the current URL as intended URL before redirecting to login
    // Only store if we're not already on an auth-related page
    const currentPath = window.location.pathname + window.location.search;
    if (!currentPath.includes('code=') && !currentPath.includes('errorLogin')) {
        localStorage.setItem('intendedUrl', currentPath);
    } else {
        localStorage.removeItem('intendedUrl');
    }

    axiosInstance
        .post(`microapi/logout-cleanup/`, {}, {
        })
        .then(() => {
            // Handle the response as needed
            // Redirect the user to the OAuth2 authorization URL
            window.location.href = authUrl;


        })
        .catch((error) => {
            // Handle logout error silently
        });
}
export function initiateLogin(): void {
    const authUrl: any = import.meta.env.VITE_AUTH_URL;

    // Store the current URL as the intended URL before redirecting to login
    localStorage.setItem('intendedUrl', window.location.pathname + window.location.search);

    // Redirect the user to the OAuth2 authorization URL if it's defined
    if (authUrl) {
        window.location.href = authUrl;
    } else {
        console.error("Authorization URL is not defined.");
    }
}

export const collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: 'base'
});

export const getBatteryStatus = (status: string) => {
    const statusCharging = ["Preparing", "Finishing", "Charging"];
    const statusAvailable = ["Available"];
    const statusFaulted = ["Faulted", "SuspendedEVSE", "SuspendedEV"];

    if (statusCharging.includes(status)) {
        return 'charging'
    }

    if (statusFaulted.includes(status)) {
        return 'faulted'
    }

    if (statusAvailable.includes(status)) {
        return 'available'
    }
    else
        return status
}

export const PAGESIZE = 8;

export const timezoneAbbreviations: any = {
    '+00:00': 'GMT',
    '-01:00': 'CVT', // Cape Verde Time
    '-02:00': 'ART', // Argentina Time
    '-03:00': 'BRT', // Brasília Time
    '-03:30': 'NST', // Newfoundland Standard Time
    '-04:00': 'AST', // Atlantic Standard Time
    '-05:00': 'EST', // Eastern Standard Time
    '-06:00': 'CST', // Central Standard Time
    '-07:00': 'MST', // Mountain Standard Time
    '-08:00': 'PST', // Pacific Standard Time
    '-09:00': 'AKST', // Alaska Standard Time
    '-10:00': 'HST', // Hawaii-Aleutian Standard Time
    '-11:00': 'SST', // Samoa Standard Time
    '-12:00': 'BIT', // Baker Island Time
    '+01:00': 'CET', // Central European Time
    '+02:00': 'EET', // Eastern European Time
    '+03:00': 'MSK', // Moscow Time
    '+03:30': 'IRST', // Iran Standard Time
    '+04:00': 'GET', // Georgia Time
    '+04:30': 'AFT', // Afghanistan Time
    '+05:00': 'PKT', // Pakistan Standard Time
    '+05:30': 'IST', // Indian Standard Time
    '+05:45': 'NPT', // Nepal Time
    '+06:00': 'BST', // Bangladesh Standard Time
    '+06:30': 'CCT', // Cocos Islands Time
    '+07:00': 'WIB', // Western Indonesian Time
    '+08:00': 'CST', // China Standard Time
    '+09:00': 'JST', // Japan Standard Time
    '+09:30': 'ACST', // Australian Central Standard Time
    '+10:00': 'AEST', // Australian Eastern Standard Time
    '+11:00': 'SBT', // Solomon Islands Time
    '+12:00': 'FJT', // Fiji Time
    '+13:00': 'PHOT', // Phoenix Island Time
    '+14:00': 'LINT', // Line Islands Time
};

export const getTimezoneAbbreviation = () => {
    const offsetMinutes = new Date().getTimezoneOffset();
    const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
    const offsetSign = offsetMinutes > 0 ? '-' : '+';
    const offsetString = `${offsetSign}${String(offsetHours).padStart(2, '0')}:${String(Math.abs(offsetMinutes) % 60).padStart(2, '0')}`;
    return timezoneAbbreviations[offsetString] || `GMT${offsetString}`;
};

export function truncateByCharacterCount(text: string) {
    return text; // Return original text if it's within the limit
}

export const timeOptions = [
    { value: "lasthour", label: "Last Hour" },
    { value: "last24hour", label: "Last 24 hours" },
    { value: "today", label: "Today" },
    { value: "last2days", label: "Last 2 Days" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "last30days", label: "Last 30 Days" },
    { value: "thisweek", label: "This Week" },
    { value: "lastweek", label: "Last Week" },
    { value: "thismonth", label: "This Month" },
    { value: "lastmonth", label: "Last Month" },
    { value: "last3month", label: "Last 3 Months" },
    { value: "last6month", label: "Last 6 Months" },
    { value: "date", label: "Custom" },
]

export function getDateTimeRange(option: any) {
    const currentDate = dayjs();
    let startDate, endDate;

    switch (option) {
        case "lasthour":
            startDate = currentDate.subtract(1, 'hour');
            endDate = currentDate;
            break;
        case "last24hour":
            startDate = currentDate.subtract(24, 'hour');
            endDate = currentDate;
            break;
        case "today":
            startDate = currentDate.startOf('day');
            endDate = currentDate.endOf('day');
            break;
        case "last2days":
            startDate = currentDate.subtract(2, 'day');
            endDate = currentDate;
            break;
        case "last7days":
            startDate = currentDate.subtract(7, 'day');
            endDate = currentDate;
            break;
        case "last30days":
            startDate = currentDate.subtract(30, 'day');
            endDate = currentDate;
            break;
        case "thisweek":
            startDate = currentDate.startOf('week');
            endDate = currentDate.endOf('week');
            break;
        case "lastweek":
            startDate = currentDate.subtract(1, 'week').startOf('week');
            endDate = currentDate.subtract(1, 'week').endOf('week');
            break;
        case "thismonth":
            startDate = currentDate.startOf('month');
            endDate = currentDate.endOf('month');
            break;
        case "lastmonth":
            startDate = currentDate.subtract(1, 'month').startOf('month');
            endDate = currentDate.subtract(1, 'month').endOf('month');
            break;
        case "last3month":
            startDate = currentDate.subtract(3, 'month');
            endDate = currentDate;
            break;
        case "last6month":
            startDate = currentDate.subtract(6, 'month');
            endDate = currentDate;
            break;
        case "date": // Custom, let user set manually
            return; // Skip setting here
        default:
            startDate = currentDate.startOf('day');
            endDate = currentDate;
            break;
    }

    return { startDate, endDate };
}

export const filterBattery = (voltage: any, batteryData: any, notliveData: any, batteryFilter: any) => batteryFilter.some((filter: any) => {
    switch (filter) {
        case 'na':
            return !batteryData;
        case 'noVoltage':
            return !notliveData && voltage === 0;
        case 'offline':
            return notliveData || (voltage === 'N/A') || (voltage < 0);
        case 'low':
            return !notliveData && (voltage !== 'N/A') && voltage < 10 && voltage >= 0;
        case 'moderate':
            return !notliveData && (voltage !== 'N/A') && voltage >= 10 && voltage < 12;
        case 'good':
            return !notliveData && (voltage !== 'N/A') && voltage >= 12;
        default:
            return false;
    }
})

export const axiosInstance = axios.create({
    baseURL: `${protocol}${url}`,
    withCredentials: true,
    // timeout: 45000
});

export const handleRefresh = async (dispatch: any, selectedCustomerName: string, customerSites: CustomerSite[], selectedSite: string) => {
    const siteId = customerSites.find(site => site.name === selectedSite)?.id;

    // Dispatch all refresh actions in parallel and wait for completion
    await Promise.all([
        dispatch(fetchMaintenanceTickets({
            requestedSchema: selectedCustomerName,
            selectedSite: siteId
        })),
        dispatch(fetchMaintRegistry({
            requestedSchema: selectedCustomerName,
            selectedSite: siteId,
        })),
        siteId
            ? dispatch(fetchBPLiveDataForCustomerForOneSite({ selectedCustomerName, site_id: siteId }))
            : dispatch(fetchBPLiveDataForCustomer({ selectedCustomerName }))
    ]);
}

export const ICON_MAP: Record<string, { default: string; selected: string }> = {
    [POWER_GENERATION]: { default: PowerSVG, selected: PowerGreen },
    [FUEL]: { default: Fuel, selected: FuelGreen },
    [SOLAR]: { default: Solar, selected: SolarGreen },
    [STARLINK]: { default: StarLink, selected: StarLinkGreen },
    [REPORTS]: { default: Reports, selected: ReportsGreen },
    [CAMERAS]: { default: Cameras, selected: CamerasGreen },
    [ALARMS]: { default: Alarms, selected: AlarmsGreen },
    [MAPS]: { default: Maps, selected: MapsGreen },

    [CHARGERS]: { default: Charger, selected: ChargerGreen },
    [FACTORY_DASHBOARD]: { default: factory, selected: factoryGreen },
    [GENERAL]: { default: General, selected: GeneralGreen },
    [MAINTENANCE]: { default: Maintenance, selected: MaintenanceGreen },
    [GLOBAL_MAPS]: { default: globalDashboard, selected: globalDashboardGreen },
    [REMOTE]: { default: General, selected: GeneralGreen },
    [EVENTS]: { default: Events, selected: EventsGreen },
    [LOGS]: { default: Loki, selected: LokiGreen }
};

export const FactoryPathUrl = (FactoryPath: boolean): boolean => FactoryPath && window.location.pathname.includes('view/FactoryDashboard');

export const ExecutiveDashboardUrl = (ExecutivePath: boolean): boolean => ExecutivePath && window.location.pathname.includes('view/ExecutiveDashboard');

export function capitalizeFirstLetter(str: string) {
    if (!str) return str;  // Check for empty string or null/undefined
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const handleAuthorizationCode = (code: string, setAuthLoading: React.Dispatch<React.SetStateAction<boolean>>, setLoginStatus: React.Dispatch<React.SetStateAction<string>>, navigate: (path: string) => void) => {
    setAuthLoading(true);
    // Create FormData object
    const formData = new FormData();

    // Append the authorization code to the FormData
    formData.append("code", code);

    // Perform the axios request
    axiosInstance
        .post(`oauth/auth0/`, formData, {
            headers: {
                "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
            }
        })
        .then(() => {
            // Handle the response as needed
            // Now that the authentication is successful, switch to sending cookies
            axios.defaults.withCredentials = true;

            localStorage.setItem('user', 'true');
            setLoginStatus('success');

            // Check if there's an intended URL to redirect to
            const intendedUrl = localStorage.getItem('intendedUrl');
            if (intendedUrl) {
                localStorage.removeItem('intendedUrl');
                navigate(intendedUrl);
            } else {
                navigate("/");
            }
        })
        .catch((error) => {
            // Handle authentication error
            if (error.response.status === 401) {
                clearCookie();
            }
            setLoginStatus('error');
            if (error.response.status === 400) {
                navigate("/errorLogin");
            }
            // initiateLogin();
        }).finally(() => {
            setAuthLoading(false);
        });
};

export const getItem = (
    label: string,
    key: string,
    icon: JSX.Element | undefined,
    children: null,
    onClick: any,
    disabled?: boolean,
    onTitleClick?: any
) => ({
    label,
    key,
    icon,
    children,
    onClick,
    disabled,
    onTitleClick,
});

export function transformString(input: string) {
    const regex = /[^_]+_(.+)/;
    const transformedString = input.replace(regex, (_, suffix) => {
        const replacedUnderscores = suffix.replace(/_/g, ' ');
        const withSpacesBeforeCaps = replacedUnderscores.replace(/([A-z0-9])([A-Z])/g, '$1 $2');
        return withSpacesBeforeCaps.replace(/\bCharger\b/g, 'Charger(s)');
    });

    return transformedString;
}

// Company headquarters locations
export interface HeadquartersLocation {
    name: string;
    address: string;
    coordinates: {
        lat: number;
        lng: number;
    };
}

export const HEADQUARTERS_LOCATIONS: HeadquartersLocation[] = [
    {
        name: "Fort Lee, NJ (Corporate HQ)",
        address: "One Parker Plaza, 400 Kelby Street, 12th Floor, Fort Lee, NJ 07024",
        coordinates: { lat: 40.8563, lng: -73.9736 }
    },
    {
        name: "Champlin, MN",
        address: "8900 109th Ave N, Suite 800, Champlin, MN 55316",
        coordinates: { lat: 45.1539, lng: -93.3932 }
    },
    {
        name: "Miami, FL",
        address: "1908 NW 84th Ave, Miami, FL 33126",
        coordinates: { lat: 25.7990, lng: -80.2990 }
    },
    {
        name: "Los Angeles, CA",
        address: "10640 Springdale Avenue, Santa Fe Springs, CA 90670",
        coordinates: { lat: 33.9472, lng: -118.0853 },
    }
];